<template>
  <div class="group-filter">
    <i class="fa fa-group"></i>
    <multiselect label="name" id="groupfilter" v-model="group" :options="groups" :searchable="false"
                 :close-on-select="true" @de :show-labels="false" placeholder="Gruppe wählen"
                 @select="handleGroupSelected" @remove="handeDeslect"></multiselect>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
export default {
  name: 'GroupFilter',
  props: ['groups'],
  components: {
    Multiselect
  },
  data() {
    return {
      group: null,
    }
  },
  methods: {
    handleGroupSelected(selectedOption) {
      this.$parent.$emit('filter', {data: selectedOption, filter: 'group'});
    },
    handeDeslect(){
      this.$parent.$emit('filter', {data: null, filter: 'group'});
    }
  },
  computed: {
  },
}
</script>
<style lang="scss" scoped>
.group-filter {
  position: relative;
  margin: 0 5px 0 5px;
  width: 100%;
  i {
    position: absolute;
    top: 25px;
    right: 1em;
    transform: translateY(-50%);
    z-index: 9992;
  }
}
</style>
